<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id,
        status
      }"
    />
    <Multiselect
      :id="id"
      ref="multiselect"
      :value="value"
      :customLabel="customLabel"
      :placeholder="disabled ? '—' :(placeholder || 'Type to search for requirement sets')"
      openDirection="bottom"
      :options="selectOptionsFiltered"
      :loading="isLoading"
      :internalSearch="false"
      :limitText="limitText"
      :showNoOptions="true"
      :showNoResults="true"
      :multiple="config.multiple"
      class="mb-2"
      :disabled="disabled"
      @input="update"
      @search-change="asyncFind"
    >
      <template slot="noOptions">
        Search to find requirement sets.
      </template>
      <template slot="noResult">
        No requirement sets found.
      </template>
    </Multiselect>
  </div>
</template>
<script>
import FormMixin from './FormMixin'
import { mapGetters } from 'vuex'
import { getRequisiteSets } from '@/api'
import _debounce from 'lodash/debounce'
import Multiselect from '@/components/Multiselect'
import { DEBOUNCE_INTERVAL } from '@/constants/'
import FormLabel from './FormLabel'
import { inject } from '@vue/composition-api'

export default {
  mixins: [ FormMixin ],
  components: { Multiselect, FormLabel },
  props: {
    excludedIds: {
      type: Array,
      default: () => ([]),
    },
    includedIds: {
      type: Array,
      default: () => ([]),
    },
    config: {
      type: Object,
      default: () => ({
        multiple: true,
      }),
    },
  },
  data () {
    return {
      selectOptions: [],
      isLoading: false,
      searchQuery: null,
    }
  },
  setup () {
    const effectiveDatesRange = inject('effectiveDatesRange', '')

    return {
      effectiveDatesRange,
    }
  },
  computed: {
    ...mapGetters([ 'school' ]),
    ...mapGetters('curriculumPrograms', [ 'requisiteSetById' ]),
    searchConfig () {
      return {
        school: this.school,
        searchQuery: this.searchQuery,
        effectiveDatesRange: this.config.effectiveDatesRange || this.effectiveDatesRange,
      }
    },
    selectOptionsFiltered () {
      return this.selectOptions
        .filter(requisiteSetId => !this.excludedIds.includes(requisiteSetId))
        .filter(requisiteSetId => !this.includedIds.length || this.includedIds.includes(requisiteSetId))
    },
  },
  methods: {
    limitText (count) {
      return `and ${count} other requirement sets`
    },
    customLabel (value) {
      const requisiteSet = this.requisiteSetById(value)
      return requisiteSet?.name || 'Untitled Requirement Set'
    },
    asyncFind (query) {
      if (query) {
        this.isLoading = true
        this.getRequisiteSetsDebounced(query)
      } else {
        this.isLoading = false
      }
    },
    getRequisiteSetsDebounced: _debounce(function (query) {
      this.getRequisiteSets(query)
    }, DEBOUNCE_INTERVAL),
    getRequisiteSets (query) {
      this.searchQuery = query

      getRequisiteSets(this.searchConfig).then((data = []) => {
        this.selectOptions = data.map(el => {
          this.$store.commit('curriculumPrograms/setRequisiteSets', {
            [el.requisiteSetGroupId]: el,
          })

          return el.requisiteSetGroupId
        })

        this.isLoading = false
      })
    },
  },
}
</script>

<style scoped>
.form-control {
  height: 36px;
}
.multiselect >>> .multiselect__tag {
  white-space: normal;
}
.multiselect >>> .multiselect__tags {
  overflow: hidden;
}
</style>
